import dayjs from 'dayjs';
import gql from 'graphql-tag';

import { useMetricQueries } from '../../lib/hooks';
import { createBatchedFetcher } from '../../lib/gqlFetcher_myf2b';

const fetcher = createBatchedFetcher(400);

const QUERY = gql`
	query metrics_contentTreeProgressSummary(
		$entityType: EntityType!,
		$entityId: ID!,
		$curriculumId: String!,
		$path: ContentTreePath!,
	) {
		metrics(entityId: $entityId, entityType: $entityType) {
			contentTreeProgressSummary(curriculumId: $curriculumId, path: $path){
				averageScore
				totalTime
				writingsCount
				lastAttemptAt
			}
		}
	}
`;

const useContentTreeProgressSummaries = (entities) => useMetricQueries(
	entities.map(
		([entityType, entityId, curriculumId, path]) => ({
			document: QUERY,
			variables: { entityType, entityId, curriculumId, path },
			options: {
				queryKey: ['metrics_contentTreeProgressSummary', entityType, entityId, curriculumId, path],
				transformer: ({ metrics: { contentTreeProgressSummary: { lastAttemptAt, ...rest } } }) => ({
					entityType,
					entityId,
					curriculumId,
					path,
					summary: {
						...rest,
						lastAttemptAt: lastAttemptAt && dayjs(lastAttemptAt),
					},
				}),
			},
		})
	),
	fetcher,
);
export default useContentTreeProgressSummaries;
